import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate, useParams } from "react-router-dom";
import AlertService from "./../../helpers/services/alertService";
import MainService from "../../helpers/services/mainService";
import { ApiService } from "../../helpers/services/apiSrevice";
import { useDispatch, useSelector } from "react-redux";
import { setToken, setUserData } from "../../store/reducers/userReducer";
import { IdentityService } from "../../helpers/services/identityService";
import { IoSearch } from "react-icons/io5";
import { ImSpinner3 } from "react-icons/im";



const OrderModal = ({ isOpen, onClose, courseData, getCourseById }) => {
	const [isOk1, setIsOk1] = useState(false);
	// const [marketingConsent, setMarketingConsent] = useState(false);
	const [values, setValues] = useState({
		fullName: "",
		email: "",
		phoneNumber: "",
		courseId: courseData.id,
		promoCode: "",
		marketingConsent: false,
	});
	const navigate = useNavigate();
	const { user } = useSelector(state => state.user);
	const dispatch = useDispatch();
	const [isShowLoader, setIsShowLoader] = useState(false);
	const [promoCode, setPromoCode] = useState("");
	const [isPromoCodeLoading, setIsPromoCodeLoading] = useState(false);
	const [isEmailExist, setIsEmailExist] = useState("");
	const [paymentProvider, setPaymentProvider] = useState("CloudPayments");
	const handleInputChange = e => {
		const { name, value } = e.target;
		setValues(prev => ({ ...prev, [name]: value }));
	};
	const [promoCodeData, setPromoCodeData] = useState(null);
	const [isDisabledFields, setIsDisabledFields] = useState(false);

	useEffect(() => {
		if (user) {
			setValues(values => ({ ...values, ...user }));
		}
	}, [user]);

	const onTransactionPurchaseCourse = () => {
		setIsShowLoader(true);
		MainService.callApi({
			api: ApiService.transactionPurchaseCourse,
			data: { id: courseData.id, promoCode: values.promoCode, provider: paymentProvider },
			cb: response => {
				if (response && response.data) {
					setTimeout(() => {
						window.location = response.data;
					}, 100);
				}
			},
			getFail: error => { },
			_finally: () => {
				setTimeout(() => {
					setIsShowLoader(false);
				}, 1000);
			},
		});
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (!isOk1) {
			alert(
				"Вы должны согласиться с условиями оферты и политики конфиденциальности.",
			);
			return;
		}

		let valuesCopy = { ...values };

		if (user) {
			onTransactionPurchaseCourse();
		} else {
			if (isEmailExist) {
				setIsShowLoader(true);
				login({ userName: values.email, password: values.password }, null);
			} else {
				setIsShowLoader(true);
				MainService.callApi({
					api: ApiService.signupWithPayment,
					data: { ...valuesCopy, paymentProvider: paymentProvider },
					cb: response => {
						if (response && response.data) {
							login(response.data, response.data.paymentUrl);
						}
					},
					getFail: error => setIsShowLoader(false),
				});
			}
		}
	};

	const login = async (_values, paymentUrl) => {
		setIsShowLoader(true);
		if (!_values) return null;
		const formData = new FormData();
		formData.append("username", _values.userName);
		formData.append("password", _values.password);
		try {
			const response = await IdentityService.userLogin(formData);
			if (response && response.data) {
				const token = response.data.accessToken;
				if (token) {
					localStorage.setItem("token", token);
					dispatch(setToken(token));
					setTimeout(() => {
						getCurrentUser(paymentUrl);
					}, 100);
				} else {
					throw new Error("Неверный адрес электронной почты или пароль.");
				}
			}
		} catch (error) {
			AlertService.alert("warning", error.message);
		} finally {
			if (!paymentUrl) {
				setTimeout(() => {
					setIsShowLoader(false);
				}, 3000);
			}
		}
	};

	// const getCurrentUserFromOrderModal = async () => {
	// 	try {
	// 		const userResponse = await ApiService.getCurrentUserFromOrderModal();
	// 		dispatch(setUserData(userResponse.data));
	// 		setTimeout(() => {
	// 			onTransactionPurchaseCourse();
	// 		}, 300);
	// 	} catch (error) {
	// 		AlertService.alert("warning", error);
	// 		navigate("/logout");
	// 	}
	// };

	const getCurrentUser = async paymentUrl => {
		try {
			const userResponse = await ApiService.getCurrentUserFromOrderModal();
			dispatch(setUserData(userResponse.data));
			if (paymentUrl) {
				setTimeout(() => {
					window.location = paymentUrl;
				}, 300);
			} else {
				getCourseById(courseData.id);
				handleClose();
			}
		} catch (error) {
			AlertService.alert("warning", error);
			navigate("/logout");
			handleClose();
		}
	};

	const checkPromoCode = e => {
		e.preventDefault();
		setIsPromoCodeLoading(true);
		MainService.callApi({
			api: ApiService.validatePromoCode,
			data: { promoCode },
			// buttonSpinner: Math.random().toString(),
			cb: response => {
				if (response && response.data) {
					if (response.data.isValid) {
						setPromoCodeData(response.data);
						setValues(values => ({
							...values,
							promoCode: promoCode,
						}));
					} else {
						setPromoCodeData(null);
					}
				}
			},
			_finally: () => {
				setIsPromoCodeLoading(false);
			},
		});
	};

	const checkEmailIsExist = () => {
		if (!values.email.trim().length) {
			return false;
		}
		setIsDisabledFields(true);
		MainService.callApi({
			api: ApiService.checkEmailIsExist,
			data: { email: values.email },
			cb: response => {
				if (response && response.data && response.data.length) {
					setIsEmailExist(response.data);
					// AlertService.alert("warning", response.data);
				} else {
					setIsEmailExist("");
				}
			},
			_finally: () => {
				setIsDisabledFields(false);
			},
		});
	};

	function applyPercentage(value, percent) {
		const pracentValue = (value * percent) / 100;
		return value - pracentValue;
	}

	if (!isOpen || !courseData) return null;

	const handleClose = () => {
		onClose();
		setIsEmailExist("");
		setValues(values => ({
			...values,
			fullName: "",
			email: "",
			phoneNumber: "",
			promoCode: "",
		}));
		setPaymentProvider("CloudPayments");
	};

	return (
		<div className="order-modal-overlay text-dark" onClick={handleClose}>
			<div className="order-modal" onClick={e => e.stopPropagation()}>
				<div className="modal-header">
					<h2>
						{courseData.title}
						<br />
						{courseData?.finalPrice}
					</h2>
					<IoClose
						className="close-icon mb-1"
						size={24}
						onClick={handleClose}
					/>
				</div>
				<hr style={{ margin: "10px 0" }} />
				<div
					className={`price-summary${promoCodeData && promoCodeData.isValid ? " active-promocode" : ""
						}`}>
					Сумма:{" "}
					{/* {courseData?.ongoingDiscount &&
						courseData?.ongoingDiscount?.discountedPrice &&
						promoCodeData &&
						promoCodeData.discountPercentage
						? applyPercentage(
							courseData?.ongoingDiscount?.discountedPrice,
							promoCodeData.discountPercentage,
						)
						: courseData?.ongoingDiscount &&
							courseData?.ongoingDiscount?.discountedPrice
							? courseData?.ongoingDiscount?.discountedPrice
							: courseData.basePrice &&
								promoCodeData &&
								promoCodeData.discountPercentage
								? applyPercentage(
									courseData.basePrice,
									promoCodeData.discountPercentage,
								)
								: courseData.basePrice}{" "} */}
					{
						promoCodeData && promoCodeData.discountPercentage && courseData.finalPrice ?
							applyPercentage(
								courseData.finalPrice,
								promoCodeData.discountPercentage,
							)
							: courseData?.finalPrice
					}
					{" "}
					р.
				</div>
				<div className="modal-form mb-3">
					<label className="mb-2">Платежная система</label>
					<div className="payment-provider-options">
						<button
							type="button"
							className={`payment-provider-button cloud-payments ${paymentProvider === "CloudPayments" ? "active" : ""}`}
							aria-pressed={paymentProvider === "CloudPayments"}
							onClick={() => setPaymentProvider("CloudPayments")}
						>
							<span className="provider-title">Cloud</span>
							<span className="provider-subtitle">Иностранные платежи</span>
						</button>
						<button
							type="button"
							className={`payment-provider-button t-bank ${paymentProvider === "TBank" ? "active" : ""}`}
							aria-pressed={paymentProvider === "TBank"}
							onClick={() => setPaymentProvider("TBank")}
						>
							<span className="provider-title">T-Bank</span>
							<span className="provider-subtitle">Платежи из РФ</span>
						</button>
					</div>
				</div>
				<div className="modal-form mb-3 d-flex gap-2">
					<input
						type="text"
						name="promoCode"
						placeholder="Промокод (если есть)"
						className="mb-0"
						value={promoCode}
						disabled={promoCodeData && promoCodeData.isValid ? true : false}
						autoComplete="new-password"
						onChange={event => setPromoCode(event.target.value)}
					/>
					{!isPromoCodeLoading ? (
						<Button
							variant="dark"
							onClick={checkPromoCode}
							className="promo-code-search-icon"
							disabled={!promoCode.trim().length || (promoCodeData && promoCodeData.isValid)}>
							<IoSearch size={22} />
						</Button>
					) : (
						<Button variant="dark" disabled className="promo-code-loader">
							<ImSpinner3 size={22} className="spinner-rotate" />
						</Button>
					)}
				</div>
				<form className="modal-form" onSubmit={handleSubmit}>
					<input
						type="text"
						name="fullName"
						placeholder="Ф.И.О."
						disabled={user}
						value={values.fullName}
						onChange={handleInputChange}
						autoComplete="new-password"
						required={isEmailExist ? false : true}
					/>
					<input
						type="email"
						name="email"
						disabled={user}
						placeholder="Ваша Почта"
						value={values.email}
						autoComplete="new-password"
						onChange={event => {
							setIsOk1(false);
							handleInputChange(event);
							setValues((values) => ({
								...values,
								marketingConsent: false
							}))
						}}
						required
						onBlur={checkEmailIsExist}
					/>
					{isEmailExist ? (
						<p style={{ lineHeight: "norml" }}>{isEmailExist}</p>
					) : null}
					<input
						type="tel"
						name="phoneNumber"
						disabled={user}
						placeholder="Ваш Телефон"
						value={values.phoneNumber}
						onChange={handleInputChange}
						autoComplete="new-password"
						required={isEmailExist ? false : true}
					/>
					{isEmailExist ? (
						<input
							type="password"
							name="password"
							placeholder="Введите пароль"
							value={values.password}
							onChange={handleInputChange}
							autoComplete="new-password"
							required={isEmailExist ? true : false}
						/>
					) : null}

					<div class="form-check govorok-checkBox">
						<input
							class="form-check-input"
							type="checkbox"
							id="isOk1"
							checked={isOk1}
							onChange={e => setIsOk1(e.target.checked)}
						/>
						<img
							src="/icons/check.svg"
							className="check_img"
							onClick={e => {
								setIsOk1(!isOk1);
							}}
							alt="/"
						/>
						<label class="form-check-label" htmlFor="isOk1">
							<p>
								<span>Я согласен(-на) с условиями </span>
								<Link to="/offer" target="_blank">
									Оферты
								</Link>{" "}
								<span>и </span>
								<Link to="/privacy-policy" target="_blank">
									Политики Конфиденциальности
								</Link>
							</p>
						</label>
					</div>
					<div class="form-check govorok-checkBox">
						<input
							class="form-check-input"
							type="checkbox"
							id="marketingConsent"
							checked={values.marketingConsent}
							onChange={e =>
								setValues((values) => ({
									...values,
									marketingConsent: e.target.checked
								}))
							}
						/>
						<img
							src="/icons/check.svg"
							className="check_img"
							onClick={e => {
								// setMarketingConsent(!marketingConsent);
								setValues((values) => ({
									...values,
									marketingConsent: !values.marketingConsent
								}))
							}}
							alt="/"
						/>
						<label class="form-check-label" htmlFor="marketingConsent">
							Даю согласие на получение рекламной рассылки
						</label>
					</div>
					<Button
						type="submit"
						className="submit-button radius-20 mt-2"
						disabled={
							!isOk1 ||
							isShowLoader ||
							isPromoCodeLoading ||
							isDisabledFields
						}>
						{isShowLoader ? "Загрузка..." : "Купить"}
					</Button>
				</form>
			</div>
		</div>
	);
};

export default OrderModal;
